import React, { useState } from 'react';
import Modal from '../base/Modal';
import { IoMdClose } from 'react-icons/io';
import { FiZap } from 'react-icons/fi';

const PromptSelectorModal = ({ isOpen, onClose, setInputValue, setInput }) => {

    const handlePromptClick = (promptText) => {
        setInputValue(promptText)
        setInput(promptText)
        setTimeout(() => {
            onClose();
        }, 200);
    };

    if (!isOpen) return null;

    return (
        <>
            {/* Backdrop */}
            <div
                className="fixed inset-0 z-[110] bg-black bg-opacity-50"
                onClick={onClose}
            ></div>

            {/* Modal */}
            <div className="fixed top-1/2 left-1/2 z-[120] w-[90vw] max-w-4xl max-h-[85vh] transform -translate-x-1/2 -translate-y-1/2 bg-zinc-900 border border-zinc-700 rounded-lg shadow-2xl flex flex-col">

                {/* Header */}
                <header className="flex items-center justify-between p-4 border-b border-zinc-700 flex-shrink-0">
                    <div className="flex items-center gap-3">
                        <FiZap className="text-[#5754CF] text-xl" />
                        <h3 className="text-lg font-semibold text-white">Choose frequent prompts</h3>
                    </div>
                    <button
                        onClick={onClose}
                        className="p-1 rounded-full hover:bg-zinc-700 text-gray-400 hover:text-white transition-colors"
                    >
                        <IoMdClose size={20} />
                    </button>
                </header>

                {/* Content */}
                <div className="flex-1 p-6 overflow-y-auto">
                    <p className="text-gray-400 text-sm mb-6 text-center">
                        Choose a prompt to get started with your analysis
                    </p>

                    {/* Prompts Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
                        {prompts.map((prompt) => (
                            <div
                                key={prompt.id}
                                onClick={() => handlePromptClick(prompt.text)}
                                className="group relative bg-zinc-800/50 border border-zinc-700 rounded-lg p-4 cursor-pointer transition-all duration-300 hover:bg-zinc-800 hover:border-[#5754CF] hover:shadow-lg hover:shadow-[#5754CF]/10"
                            >
                                {/* Icon and Category Badge */}
                                {/* <div className="flex items-start justify-between mb-3">
                                    <div></div>
                                    <span className="inline-block bg-[#5754CF]/20 text-[#5754CF] border border-[#5754CF]/30 text-[0.65rem] font-semibold px-2 py-0.5 rounded-full uppercase tracking-wider">
                                        {prompt.category}
                                    </span>
                                </div> */}

                                {/* Content */}
                                <div className="space-y-2">
                                    <h4 className="text-base font-semibold text-white group-hover:text-[#5754CF] transition-colors">
                                        {prompt.title}
                                    </h4>

                                    <p className="text-sm text-gray-400 leading-relaxed line-clamp-2">
                                        {prompt.text}
                                    </p>
                                </div>

                                {/* Arrow indicator */}
                                <div className="absolute bottom-3 right-3 text-[#5754CF] opacity-0 translate-x-[-8px] transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0">
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                                    </svg>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </>
    );
};

export default PromptSelectorModal;

const prompts = [
    {
        id: 1,
        icon: '💰',
        title: 'Payment Analysis',
        text: 'How many payments are pending for the last 2 months?',
        category: 'Finance'
    },
    {
        id: 2,
        icon: '📊',
        title: 'Revenue Tracking',
        text: 'What is our total revenue for Q1 2026 compared to Q4 2025?',
        category: 'Finance'
    },
    {
        id: 3,
        icon: '👥',
        title: 'Customer Insights',
        text: 'Show me the top 10 customers by order value this month',
        category: 'Sales'
    },
    {
        id: 4,
        icon: '📈',
        title: 'Sales Performance',
        text: 'What are our best-selling products in the last quarter?',
        category: 'Sales'
    },
    {
        id: 5,
        icon: '⏱️',
        title: 'Overdue Invoices',
        text: 'List all invoices overdue by more than 30 days',
        category: 'Finance'
    },
    {
        id: 6,
        icon: '🎯',
        title: 'Goal Tracking',
        text: 'How close are we to achieving our monthly sales target?',
        category: 'Sales'
    },
    {
        id: 7,
        icon: '📦',
        title: 'Inventory Status',
        text: 'Which products have stock levels below reorder point?',
        category: 'Operations'
    },
    {
        id: 8,
        icon: '🔄',
        title: 'Recurring Revenue',
        text: 'Show me monthly recurring revenue trend for the past 6 months',
        category: 'Finance'
    }
];